export const CONTENT_CARD_IMAGE_HEIGHT = 275;
export const BLOG_POST_DETAILS_WIDTH = 720;
export const BLOG_POSTS_LIMIT_WIDGET = 10;
